// React
import React, { useRef, useEffect } from "react";
// React
// CSS
import styles from "./ModalForPartSelecting.module.css";
// CSS
// Models
import { I_TeachItem_Data } from "../../../Models/interfaces";
import HelperHeader from "../../../Utils/HelperHeader/HelperHeader";
// Models

type ModalForPartSelectingProps = {
  data: I_TeachItem_Data[];
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;

  setCurrMode: React.Dispatch<React.SetStateAction<"quiz" | "media">>;
  setCurrDataIndex: React.Dispatch<React.SetStateAction<number>>;

  onVideoClick: () => void;
};

const ModalForPartSelecting: React.FunctionComponent<
  ModalForPartSelectingProps
> = ({ data, setIsModalOpen, setCurrMode, setCurrDataIndex, onVideoClick }) => {
  const outerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (!outerRef.current) return;
      if (!innerRef.current) return;
      outerRef.current.style.opacity = "1";
      innerRef.current.style.top = "0";
    }, 50);
  }, []);

  return (
    <div
      className={`${styles.modalContainer} fixed top-0 ${
        window.innerWidth > 600 ? "left-auto" : "left-0"
      } w-screen h-screen flex items-center justify-center z-[300]`}
    >
      <div
        className={`${styles.outer} absolute  w-screen h-screen z-[400]`}
        onClick={() => {
          if (!outerRef.current) return;
          if (!innerRef.current) return;
          outerRef.current.style.opacity = "0";
          innerRef.current.style.top = "120vh";

          setTimeout(() => {
            setIsModalOpen(false);
          }, 500);
        }}
        ref={outerRef}
      ></div>
      <div
        className={`${styles.inner} relative z-[500] flex flex-col  items-center bg-white w-10/12 p-4 overflow-y-scroll rounded-xl`}
        ref={innerRef}
      >
        <HelperHeader absoluteText="انتـــخاب قسمت" isBgWhite={true} />
        {data.map((item, index) => (
          <button
            key={item.id}
            onClick={() => {
              if (item.is_video) {
                setCurrMode("media");
                onVideoClick();
                setCurrDataIndex(index);
                if (!outerRef.current) return;
                if (!innerRef.current) return;
                outerRef.current.style.opacity = "0";
                innerRef.current.style.top = "120vh";

                setTimeout(() => {
                  setIsModalOpen(false);
                }, 500);
              } else {
                if (item.question) {
                  setCurrMode("quiz");
                  setCurrDataIndex(index);
                  if (!outerRef.current) return;
                  if (!innerRef.current) return;
                  outerRef.current.style.opacity = "0";
                  innerRef.current.style.top = "120vh";

                  setTimeout(() => {
                    setIsModalOpen(false);
                  }, 500);
                }
              }
            }}
            className={`my-4 w-full text-right text-sm ${
              !item.is_video ? "text-blue-500" : ""
            }`}
          >
            <> &nbsp; قسمت {index + 1} : </>
            {item.is_video ? "آموزش" : "پرسش"}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ModalForPartSelecting;
